import React, { ReactElement, ReactNode, useEffect, useState } from 'react'
import searchFilterCookTimeConfig from '@mindfulchefuk/config/searchFilterCookTimeConfig'
import searchFilterRatingConfig from '@mindfulchefuk/config/searchFilterRatingConfig'
import {
  SEARCH_FILTER_PRIMARY_FOOD,
  SEARCH_FILTER_COOKINGTIME,
  SEARCH_FILTER_CUISINE,
  SEARCH_FILTER_CUISINE_LIMIT,
  SEARCH_FILTER_RATING,
  SEARCH_FILTER_SEASON,
} from '@mindfulchefuk/constants'
import {
  Box,
  Flex,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Stack,
} from '@mindfulchefuk/design-system'

import { TFilterDefaults } from './types'
import { ModalToggle } from './ModalToggle'
import { MenuSelect } from './MenuSelect'
import { NumericMenuSelect } from './NumericMenuSelect'
import { ClearRefinementsLink } from './ClearRefinementsLink'

const Filter = ({
  children,
  label,
}: {
  children?: ReactNode
  label: string
}) => (
  <Box>
    <Label as="div">{label}</Label>
    {children}
  </Box>
)

export const MobileFilters = ({
  filterDefaults = {},
}: {
  filterDefaults: TFilterDefaults
}): ReactElement => {
  const [modalIsActive, setModalIsActive] = useState(false)

  useEffect(() => {
    if (modalIsActive) document.body.classList.add('scrollLock')

    return () => document.body.classList.remove('scrollLock')
  }, [modalIsActive])

  const handleOpenModal = () => {
    setModalIsActive(true)
  }

  const handleCloseModal = () => {
    setModalIsActive(false)
  }

  return (
    <Box display={{ base: 'block', md: 'none' }}>
      <Box mb={16}>
        <ModalToggle onClick={handleOpenModal} />
        <Flex justify="flex-end" w="100%" mt={4}>
          <ClearRefinementsLink />
        </Flex>
      </Box>
      <Box display={modalIsActive ? 'block' : 'none'}>
        <Modal size="small" closeModal={handleCloseModal} lockScroll={false}>
          <ModalHeader closeModal={handleCloseModal}>
            <ClearRefinementsLink />
          </ModalHeader>
          <ModalBody>
            <Stack spacing={24} minWidth={[224, 320]}>
              <Filter label="Food group">
                <MenuSelect
                  attribute={SEARCH_FILTER_PRIMARY_FOOD}
                  defaultRefinement={filterDefaults[SEARCH_FILTER_PRIMARY_FOOD]}
                />
              </Filter>
              <Filter label="Cuisine">
                <MenuSelect
                  attribute={SEARCH_FILTER_CUISINE}
                  defaultRefinement={filterDefaults[SEARCH_FILTER_CUISINE]}
                  limit={SEARCH_FILTER_CUISINE_LIMIT}
                />
              </Filter>
              <Filter label="Season">
                <MenuSelect
                  attribute={SEARCH_FILTER_SEASON}
                  defaultRefinement={filterDefaults[SEARCH_FILTER_SEASON]}
                />
              </Filter>
              <Filter label="Cooking time">
                <NumericMenuSelect
                  attribute={SEARCH_FILTER_COOKINGTIME}
                  items={searchFilterCookTimeConfig}
                  defaultRefinement={filterDefaults[SEARCH_FILTER_COOKINGTIME]}
                />
              </Filter>
              <Filter label="Rating">
                <NumericMenuSelect
                  attribute={SEARCH_FILTER_RATING}
                  items={searchFilterRatingConfig}
                  defaultRefinement={filterDefaults[SEARCH_FILTER_RATING]}
                />
              </Filter>
            </Stack>
          </ModalBody>
        </Modal>
      </Box>
    </Box>
  )
}
